module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Sneakers-dbe1673366fd9d3e2ad8a28ed13142b3.svg";